(ns frontend.ux-overhaul.listing.generic.sub
  (:require-macros [ui.subs.macros :refer [<-1 <-1m]])
  (:require
   [common.opensearch.kanban-sort :as kanban-sort]
   [common.util :as cu]
   [frontend.ux-overhaul.listing.generic.event :as event]
   [frontend.ux-overhaul.listing.generic.model :as model]
   [frontend.ux-overhaul.listing.generic.selection :as selection-helpers]
   [re-frame.core :as rf]
   [ui.editors.simple-filters.sub :as simple-filters-sub]
   [ui.state.session.sub :as session-sub]
   [ui.view.grid-opensearch.event :as grid-event]
   [ui.view.grid-opensearch.model :as grid-model]))

(rf/reg-sub
 ::runtime
 (fn [db [_ listing-id]]
   (get-in db (model/listing-path listing-id))))

(rf/reg-sub
 ::params
 (<-1 ::runtime)
 (fn [runtime _]
   (:params runtime)))

(rf/reg-sub
 ::context
 (<-1 ::runtime)
 (fn [runtime _]
   (:context runtime)))

(rf/reg-sub
 ::groupable-field-paths
 (<-1 ::context)
 (fn [context _]
   (or (:groupable-field-paths context) #{})))

(rf/reg-sub
 ::view
 (<-1 ::runtime)
 (fn [runtime _]
   (:view runtime)))

(rf/reg-sub
 ::query
 (<-1 ::runtime)
 (fn [runtime _]
   (:query runtime)))

(rf/reg-sub
 ::filters
 (<-1 ::runtime)
 (fn [runtime _]
   (:filters runtime)))

(rf/reg-sub
 ::view-config
 (<-1 ::runtime)
 (fn [runtime _]
   (:view-config runtime)))

(rf/reg-sub
 ::group-by-field
 (<-1 ::view-config)
 (fn [view-config _]
   (:group-by-field view-config)))

(rf/reg-sub
 ::row-group-by-field
 (<-1 ::view-config)
 (fn [view-config _]
   (:row-group-by-field view-config)))

(rf/reg-sub
 ::row-group-sort-mode
 (<-1 ::view-config)
 (fn [view-config _]
   (kanban-sort/normalize-row-sort-mode (:row-group-sort-mode view-config))))

(rf/reg-sub
 ::kanban-column-sort-mode
 (<-1 ::view-config)
 (fn [view-config _]
   (kanban-sort/normalize-column-sort-mode (:kanban-column-sort-mode view-config))))

(rf/reg-sub
 ::kanban-card-sort-mode
 (<-1 ::view-config)
 (fn [view-config _]
   (kanban-sort/normalize-card-sort-mode (:kanban-card-sort-mode view-config))))

(rf/reg-sub
 ::hide-empty-columns?
 (<-1 ::view-config)
 (fn [view-config _]
   (boolean (:hide-empty-columns? view-config))))

(rf/reg-sub
 ::card-config-by-view-mode
 (<-1 ::view-config)
 (fn [view-config _]
   (get-in view-config [:card :by-view-mode] {})))

(rf/reg-sub
 ::card-view-config
 (<-1m ::card-config-by-view-mode ::view-mode)
 (fn [[by-view-mode view-mode] _]
   (get by-view-mode view-mode {})))

(rf/reg-sub
 ::card-show-labels?
 (<-1 ::card-view-config)
 (fn [card-view-config _]
   (if (contains? card-view-config :show-labels?)
     (boolean (:show-labels? card-view-config))
     true)))

(rf/reg-sub
 ::card-body-fields
 (<-1 ::card-view-config)
 (fn [card-view-config _]
   (vec (or (:body-fields card-view-config) []))))

(rf/reg-sub
 ::groupable-fields
 (<-1m ::context ::groupable-field-paths)
 (fn [[context groupable-field-paths] _]
   (->> (or (:accessible-fields context) [])
        (filter (fn [{:keys [field-path]}]
                  (contains? groupable-field-paths field-path)))
        vec)))

(rf/reg-sub
 ::selection
 (<-1 ::runtime)
 (fn [runtime _]
   (:selection runtime)))

(rf/reg-sub
 ::toolbar
 (<-1 ::runtime)
 (fn [runtime _]
   (:toolbar runtime)))

(rf/reg-sub
 ::data
 (<-1 ::runtime)
 (fn [runtime _]
   (:data runtime)))

(rf/reg-sub
 ::ui
 (<-1 ::runtime)
 (fn [runtime _]
   (:ui runtime)))

(rf/reg-sub
 ::entity-type
 (<-1 ::params)
 (fn [params _]
   (:entity-type params)))

(rf/reg-sub
 ::pipeline-id
 (<-1 ::params)
 (fn [params _]
   (:pipeline-id params)))

(rf/reg-sub
 ::available-view-modes
 (<-1 ::params)
 (fn [params _]
   (or (:available-view-modes params) #{})))

(rf/reg-sub
 ::filters-config
 (<-1 ::params)
 (fn [params _]
   (or (:filters params) {})))

(rf/reg-sub
 ::view-mode
 (<-1 ::view)
 (fn [view _]
   (:mode view)))

(rf/reg-sub
 ::query-text
 (<-1 ::query)
 (fn [query _]
   (or (:draft query)
       (:text query)
       "")))

(rf/reg-sub
 ::committed-query-text
 (<-1 ::query)
 (fn [query _]
   (or (:text query) "")))

(rf/reg-sub
 ::active-filters
 (<-1 ::filters)
 (fn [filters _]
   (vec (or (:active filters) []))))

(rf/reg-sub
 ::active-filter-count
 (<-1 ::active-filters)
 (fn [active-filters _]
   (count active-filters)))

(rf/reg-sub
 ::selected-filter-field-path
 (<-1 ::filters)
 (fn [filters _]
   (:selected-field-path filters)))

(rf/reg-sub
 ::po-field-paths
 (<-1 ::filters)
 (fn [filters _]
   (vec (or (:po-field-paths filters) []))))

(rf/reg-sub
 ::pinned-field-paths
 (<-1 ::filters)
 (fn [filters _]
   (vec (or (:pinned-field-paths filters) []))))

(rf/reg-sub
 ::persisted-filters-by-field-path
 (<-1 ::filters)
 (fn [filters _]
   (:persisted-by-field-path filters)))

(rf/reg-sub
 ::saved-views
 (fn [[_ listing-id]]
   [(rf/subscribe [::session-sub/legacy-entities])
    (rf/subscribe [::params listing-id])
    (rf/subscribe [::context listing-id])])
 (fn [[entities params context] [_ listing-id]]
   (model/saved-views {:entities               entities
                       :default-views          (:default-views params)
                       :listing-id             listing-id
                       :type-listing-id        (:type-listing-id params)
                       :schema-version         event/named-view-schema-version
                       :legacy-view-keys       (:legacy-view-keys params)
                       :accessible-field-paths (:accessible-field-paths context)})))

(rf/reg-sub
 ::type-listing-id
 (<-1 ::params)
 (fn [params _]
   (:type-listing-id params)))

(rf/reg-sub
 ::active-view-id
 (<-1 ::runtime)
 (fn [runtime _]
   (get-in runtime [:views :active-id])))

(rf/reg-sub
 ::active-view
 (<-1m ::saved-views ::active-view-id)
 (fn [[saved-views active-view-id] _]
   (when active-view-id
     (cu/find-first-by :db/id active-view-id saved-views))))

(rf/reg-sub
 ::grid-sorted-by
 (fn [db [_ listing-id]]
   (some-> (get-in db (grid-model/config-full-path (model/grid-id listing-id)))
           grid-event/config-sorted-by)))

(rf/reg-sub
 ::active-view-dirty?
 (fn [[_ listing-id editor-id] _]
   [(rf/subscribe [::active-view listing-id])
    (rf/subscribe [::view-config listing-id])
    (rf/subscribe [::view-mode listing-id])
    (rf/subscribe [::simple-filters-sub/filters-by-field-path editor-id])
    (rf/subscribe [::grid-sorted-by listing-id])])
 (fn [[active-view view-config view-mode filters-by-field-path grid-sorted-by] _]
   (cond
     (nil? active-view)
     nil

     (:default-view? active-view)
     (model/default-view-modified? active-view filters-by-field-path)

     :else
     (let [decoded (event/decode-saved-view-settings (:named-view/settings active-view))]
       (boolean
        (or (not= (:view-config decoded) (event/saved-view-payload view-config))
            (not= (:view-mode decoded) view-mode)
            (not= (:filters decoded) (or filters-by-field-path {}))
            (model/grid-sort-modified? {:saved-settings  decoded
                                        :live-sorted-by grid-sorted-by})))))))

(rf/reg-sub
 ::effective-filter-field-paths
 (<-1m ::po-field-paths ::pinned-field-paths)
 (fn [[po-field-paths pinned-field-paths] _]
   (->> (concat po-field-paths pinned-field-paths)
        distinct
        vec)))

(rf/reg-sub
 ::filter-manage-open?
 (<-1 ::filters)
 (fn [filters _]
   (boolean (:manage-open? filters))))

(rf/reg-sub
 ::field-search
 (<-1 ::filters)
 (fn [filters _]
   (or (:field-search filters) "")))

(rf/reg-sub
 ::facet-search
 (<-1 ::filters)
 (fn [filters _]
   (or (:facet-search filters) "")))

(rf/reg-sub
 ::facet-options-by-field
 (<-1 ::filters)
 (fn [filters _]
   (or (:facet-options-by-field filters) {})))

(rf/reg-sub
 ::facet-options-for-selected-field
 (<-1m ::selected-filter-field-path ::facet-options-by-field)
 (fn [[field-path facet-options-by-field] _]
   (vec (get facet-options-by-field field-path []))))

(rf/reg-sub
 ::loading-facets-by-field
 (<-1 ::filters)
 (fn [filters _]
   (or (:loading-facets-by-field filters) {})))

(rf/reg-sub
 ::selected-ids
 (<-1 ::selection)
 (fn [selection _]
   (set (selection-helpers/action-ids selection))))

(rf/reg-sub
 ::all-selection?
 (<-1 ::selection)
 (fn [selection _]
   (selection-helpers/all-selection? selection)))

(rf/reg-sub
 ::selected-count
 (fn [db [_ listing-id]]
   (let [selection (get-in db (model/selection-path listing-id))]
     (selection-helpers/selected-count
      selection
      (get-in db (grid-model/last-query-total-full-path (:grid-id selection)))))))

(rf/reg-sub
 ::last-selected-id
 (<-1 ::selection)
 (fn [selection _]
   (:last-selected-id selection)))

(rf/reg-sub
 ::toolbar-actions
 (<-1 ::toolbar)
 (fn [toolbar _]
   (vec (or (:actions toolbar) []))))

(rf/reg-sub
 ::visible-toolbar-actions
 (<-1m ::toolbar-actions ::ui ::selected-count ::view-mode)
 (fn [[toolbar-actions ui selected-count _view-mode] _]
   (let [disabled-by-key (or (:disabled-by-key ui) {})]
     (->> toolbar-actions
          (filter (fn [{:keys [visible?]}]
                    (not= false visible?)))
          (filter (fn [{:keys [requires-selection?]}]
                    (or (not requires-selection?)
                        (pos? selected-count))))
          (mapv (fn [{:keys [id enabled? requires-selection?] :as action}]
                  (let [disabled-by-ui? (true? (get disabled-by-key id false))
                        missing-selection? (and (true? requires-selection?)
                                                (not (pos? selected-count)))]
                    (assoc action :enabled? (and (not= false enabled?)
                                                 (not missing-selection?)
                                                 (not disabled-by-ui?))))))))))

(rf/reg-sub
 ::data-status
 (<-1 ::data)
 (fn [data _]
   (:status data)))

(rf/reg-sub
 ::items
 (<-1 ::data)
 (fn [data _]
   (vec (or (:items data) []))))

(rf/reg-sub
 ::total
 (<-1 ::data)
 (fn [data _]
   (or (:total data) 0)))

(rf/reg-sub
 ::error
 (<-1 ::data)
 (fn [data _]
   (:error data)))

(rf/reg-sub
 ::initialized?
 (<-1 ::ui)
 (fn [ui _]
   (boolean (:initialized? ui))))

(rf/reg-sub
 ::busy?
 (<-1 ::ui)
 (fn [ui _]
   (boolean (:busy? ui))))

(rf/reg-sub
 ::busy-by-key
 (<-1 ::ui)
 (fn [ui _]
   (or (:busy-by-key ui) {})))

(rf/reg-sub
 ::disabled-by-key
 (<-1 ::ui)
 (fn [ui _]
   (or (:disabled-by-key ui) {})))

(rf/reg-sub
 ::busy-key?
 (<-1 ::busy-by-key)
 (fn [busy-by-key [_ _listing-id busy-key]]
   (boolean (get busy-by-key busy-key))))

(rf/reg-sub
 ::disabled-key?
 (<-1 ::disabled-by-key)
 (fn [disabled-by-key [_ _listing-id control-key]]
   (boolean (get disabled-by-key control-key))))

(rf/reg-sub
 ::busy-reason
 (<-1 ::ui)
 (fn [ui _]
   (:busy-reason ui)))

(rf/reg-sub
 ::can-interact?
 (<-1m ::busy? ::data-status)
 (fn [[busy? data-status] _]
   (and (not busy?)
        (not= data-status :loading))))
